import React from 'react';
import DialoguePanel from '../DialoguePanel.jsx';
import TerminalBar from '../TerminalBar.jsx';

/**
 * HUD terminal zone (v3 `.tm`). The real dialogue log (DialoguePanel, store-driven)
 * plus the real input (TerminalBar -> handleTerminalInput -> the two-model LLM loop).
 * ch3 refines the log styling to the v3 terminal grammar; the wiring is already real.
 */
export default function HudTerminal({ onSubmit, disabled, interviewActive }) {
  return (
    <div className="tm">
      {/* No idle header: the LUMEN:// prompt already names the terminal. The
          header strip only appears when it has state to report. */}
      {interviewActive && (
        <div className="tm-hdr">
          <span style={{ color: 'var(--amber)', fontSize: '9px', letterSpacing: 'var(--tracking-label)', textShadow: 'var(--glow-amber)' }}>
            ● INTERVIEW ACTIVE
          </span>
        </div>
      )}
      <div className="tm-log"><DialoguePanel /></div>
      <TerminalBar onSubmit={onSubmit} disabled={disabled} />
    </div>
  );
}
